export default __webpack_public_path__ + "static/media/caret-down.4209ca4b.svg";